import { render, staticRenderFns } from "./VerifyPhone.modal.vue?vue&type=template&id=2199837f&scoped=true&"
import script from "./VerifyPhone.modal.vue?vue&type=script&lang=js&"
export * from "./VerifyPhone.modal.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPhone.modal.vue?vue&type=style&index=0&id=2199837f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199837f",
  null
  
)

export default component.exports